/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationV2Ruleset
 */
export interface MatchOperationV2Ruleset {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2Ruleset
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2Ruleset
     */
    version: number;
}

/**
 * Check if a given object implements the MatchOperationV2Ruleset interface.
 */
export function instanceOfMatchOperationV2Ruleset(value: object): value is MatchOperationV2Ruleset {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function MatchOperationV2RulesetFromJSON(json: any): MatchOperationV2Ruleset {
    return MatchOperationV2RulesetFromJSONTyped(json, false);
}

export function MatchOperationV2RulesetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2Ruleset {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'version': json['version'],
    };
}

export function MatchOperationV2RulesetToJSON(json: any): MatchOperationV2Ruleset {
    return MatchOperationV2RulesetToJSONTyped(json, false);
}

export function MatchOperationV2RulesetToJSONTyped(value?: MatchOperationV2Ruleset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'version': value['version'],
    };
}

